import { dataMember, required } from 'santee-dcts';
import { isEmpty } from 'lodash';
import * as moment from 'moment';
import { deserializers } from '../core';

export class UserInfo {
    @dataMember()
    @required()
    public userId: number;

    @dataMember()
    @required({ nullable: true })
    public userName: string;

    @dataMember()
    @required({ nullable: true })
    public firstName: string;

    @dataMember()
    @required({ nullable: true })
    public lastName: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public lastLoginDate: moment.Moment;

    @dataMember()
    @required({ nullable: true })
    public studyId: number;

    @dataMember()
    @required({ nullable: true })
    public clientProtocol: string;

    @dataMember()
    @required({ nullable: true })
    public covanceProjectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public sponsor: string;

    @dataMember()
    @required({ nullable: true })
    public siteId: number;

    @dataMember()
    @required({ nullable: true })
    public siteNum: string;

    @dataMember()
    @required({ nullable: true })
    public investigatorFullName: string;

    @dataMember()
    @required({ nullable: true })
    public region: string;

    @dataMember()
    @required({ nullable: true })
    public applicationRole: string;

    @dataMember()
    @required({ nullable: true })
    public blindingRole: string;

    public get fullName() {
        const data: string[] = [];

        if (!isEmpty(this.lastName)) {
            data.push(this.lastName);
        }

        if (!isEmpty(this.firstName)) {
            data.push(this.firstName);
        }

        return data.join(' ');
    }

    public isEmulationAvailable: boolean;
}
